import { render, staticRenderFns } from "./IndustryTrendsChild.vue?vue&type=template&id=efe58fe2&"
import script from "./IndustryTrendsChild.vue?vue&type=script&lang=js&"
export * from "./IndustryTrendsChild.vue?vue&type=script&lang=js&"
import style0 from "./IndustryTrendsChild.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports